"use client";

import {
  HeroSection,
  AppsShowcaseSection,
  OurStorySection,
  MissionVisionSection,
  LetsConnectSection,
} from "@/components/custom/home/sections";
import { AppFAQSection } from "@/components/custom/shared";
import { homeFaqs } from "./data";

const HomePage = ({ setActiveTab }) => {
  return (
    <>
      <HeroSection setActiveTab={setActiveTab} />
      <AppsShowcaseSection setActiveTab={setActiveTab} />
      <OurStorySection />
      <MissionVisionSection />
      {/* Question-phrased h2 + h3s, mirrored as FAQPage JSON-LD in app/page.jsx */}
      <AppFAQSection
        title="What can Keystone do for your Shopify store?"
        faqs={homeFaqs}
      />
      <LetsConnectSection />
    </>
  );
};

export default HomePage;
